module.exports = __webpack_public_path__ + "static/media/hold.26ffa2c9.svg";